import React, { Component } from 'react'
import { connect } from 'react-redux'
import Header from './../Components/Header/Header'
import { HeadingMain } from '../Components/Heading/HeadingMain'
import './Home.css'
import { About } from '../Components/About/About'
import { MeetMain } from '../Components/MeetUs/MeetMain'
import { Contact } from '../Components/Contact/Contact'
import { Footer } from '../Components/Footer/Footer'
import Fade from 'react-reveal/Fade'
import { OurPartners } from '../Components/Partners/OurPartners'

export class Home extends Component {
    render() {
        return (
            <div id="bg-gradient">
                <Header />
                <Fade>
                    <div className="">
                        <HeadingMain />
                    </div>
                </Fade>

                <Fade>
                    <About />
                </Fade>

                
                <MeetMain />
                

                <Fade>
                    <OurPartners />
                </Fade>

                {/* Customer Reviews go here */}

                <Fade>
                    <Contact />
                </Fade>

                <Footer />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
